import React from 'react'
import { Grid, Button, Breadcrumbs, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import './LeaderboardtabreadCrumb.css'

export default function LeaderboardtabreadCrumb({
  selectedTab,
  editData,
  setSelectedTab,
  setEditData,
  promptOnTabChange,
  setShowConfirmDialog,
  setPendingTabIndex,
}) {
  let navigate = useNavigate()

  const backToSettings = () => {
    if (promptOnTabChange) {
      setPendingTabIndex('settings')
      setShowConfirmDialog(true)
    } else {
      navigate('/Settings')
    }
  }
  const backToLeaderboardTab = () => {
    if (promptOnTabChange) {
      setPendingTabIndex(0)
      setShowConfirmDialog(true)
    } else {
      setSelectedTab(0)
      setEditData(null)
      navigate('/Settings/LeaderboardTab')
    }
  }

  const isLeaderboardTabActive = selectedTab === 0 && !editData

  return (
    <Grid container sx={{ marginLeft: '-7px' }}>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{ marginLeft: '9px' }}
        separator={<Typography variant="h5">/</Typography>}
      >
        <Button underline="hover" className="ns-update" onClick={backToSettings}>
          Settings
        </Button>
        <Button
          underline="hover"
          className={`ns-update os-text ${isLeaderboardTabActive ? 'breadcrumb-active' : ''}`}
          onClick={backToLeaderboardTab}
        >
          Leaderboard Tabs
        </Button>
        {editData ? (
          <Button underline="hover" className="ns-update os-text breadcrumbs-title breadcrumb-active">
            {editData.tabName}
          </Button>
        ) : (
          selectedTab === 1 && (
            <Button underline="hover" className="ns-update os-text breadcrumbs-title breadcrumb-active">
              Add New
            </Button>
          )
        )}
      </Breadcrumbs>
    </Grid>
  )
}
